import { DateTime } from "luxon";
import * as Yup from "yup";

import { email, guardianName, text } from "../lib/yup";

const DATE_INVALID = "invalid";

export const SeasonCardApplicationSchema = Yup.object({
  firstName: text,
  lastName: text,
  dateOfBirth: Yup.string()
    .required("validation.required")
    .test(
      "dateOfBirth",
      "validation.invalidDate",
      value => value !== DATE_INVALID,
    )
    .test("dateOfBirth", "validation.dateAfterToday", value =>
      value ? DateTime.fromISO(value) < DateTime.local() : false,
    ),
  guardianFirstName: guardianName,
  guardianLastName: guardianName,
  address: text,
  city: text,
  zip: text,
  email,
  phone: text,
  ticketId: Yup.string().optional(),
  termsAccepted: Yup.boolean().test(
    "termsAccepted",
    "validation.consent",
    Boolean,
  ),
}).required();

export type SeasonCardApplicationFields = Yup.InferType<
  typeof SeasonCardApplicationSchema
>;
